import React, { useEffect } from "react";
import { _goToAddCategory } from "routers/helper";
import { useIsFocused } from "@react-navigation/native";

import { View, SafeAreaView } from "react-native";
import {
  Error,
  Empty,
  Header,
  Loading,
  CategoryBox,
  AddButtonFloat,
  AnimatedInfinityList,
} from "components";

import { useCategories } from "clients/apis";

import { sizes, strings } from "assets/constants";
import { mq } from "utils";
import css from "styles";
import { useChmod } from "hooks";

export default function Categories() {
  const { chmod } = useChmod();

  const isFocused = useIsFocused();

  const {
    data,
    error,
    isError,
    refetch,
    isLoading,
    isRefetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useCategories();

  useEffect(() => {
    isFocused && refetch();
  }, [isFocused, refetch]);

  const _renderItem = (items: []) => {
    return (
      <View style={css.responsiveListContainer}>
        {items.map((cat: CategoryT, key: number) => (
          <View key={String(key)} style={css.responsiveBoxContainer}>
            <CategoryBox cat={cat} />
          </View>
        ))}
      </View>
    );
  };

  const _renderContent = () => {
    if (isLoading) {
      return <Loading style={{ marginTop: mq(20) }} />;
    }

    if (isError) {
      return <Error error={error} reset={refetch} loading={isRefetching} />;
    }

    if (data?.pages?.[0]?.data?.data?.length === 0) {
      return <Empty style={{ marginTop: mq(20) }} message={strings.no_cat} />;
    }

    return (
      <AnimatedInfinityList
        responseData={data}
        onRefresh={refetch}
        paddingTop={sizes.space}
        paddingBottom={50}
        renderItemList={_renderItem}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
      />
    );
  };

  return (
    <>
      <Header title={strings.product_cats} />
      <>
        <SafeAreaView style={{ ...css.container, ...css.screenBg }}>
          {_renderContent()}
          {chmod("category", "POST") && (
            <AddButtonFloat onPress={_goToAddCategory} />
          )}
        </SafeAreaView>
      </>
    </>
  );
}
